import styled from "styled-components";
import { Apartment } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { MdOutlineBrandingWatermark } from "react-icons/md";
import { Box, Paper, Typography, Avatar } from "@mui/material";

import pages from "../../../constants/pages";
import { PrimaryButton } from "../../css components/Button";

export default function WelcomeCards({ steps, verification }) {
  const navigate = useNavigate();
  const brandID = sessionStorage.getItem("brandID");
  const role = sessionStorage.getItem("role");

  return (
    <Box
      sx={{
        background: "#f6f2f9",
        minHeight: "50vh",
        p: 4,
        marginTop: "60px",
      }}
    >
      <CardWrapper>
        {/* Brand Card */}
        <Card elevation={4}>
          <StyledAvatar sx={{ bgcolor: "#028fd1" }}>
            <MdOutlineBrandingWatermark style={{ fontSize: "25px" }} />
          </StyledAvatar>
          <Typography className="card-heading" sx={{ mb: 2 }}>
            {!steps.step2
              ? "Let's start by adding the brand details."
              : "Your brand details have been added. Want to edit them?"}
          </Typography>
          <PrimaryButton variant="contained" onClick={handleBrandNavigation}>
            {!steps.step2 ? "Add Brand Details" : "Edit Brand Details"}
          </PrimaryButton>
        </Card>

        {/* Company Card */}
        {role !== "AGENCY" && (
          <Card elevation={4}>
            <StyledAvatar sx={{ bgcolor: "#8f1c82" }}>
              <Apartment style={{ fontSize: "25px" }} />
            </StyledAvatar>
            <Typography className="card-heading" sx={{ mb: 2 }}>
              {!steps.step3
                ? "Let’s add your company details."
                : "Your company details have been added. Want to edit them?"}
            </Typography>
            <PrimaryButton
              variant="contained"
              disabled={!steps.step2}
              onClick={handleCompanyNavigation}
            >
              {!steps.step3
                ? "Add Company Details"
                : "Edit Company/Agreement Details"}
            </PrimaryButton>
          </Card>
        )}
      </CardWrapper>
    </Box>
  );
  function handleBrandNavigation() {
    if (steps.step2) {
      navigate(pages.brandDetailEmpty.route + "?brandID=" + brandID);
    } else {
      navigate(pages.brandDetailEmpty.route);
    }
  }

  function handleCompanyNavigation() {
    if (steps.step3) {
      navigate(
        pages.companyDetailsEmpty.route +
          "?brandID=" +
          brandID +
          "&withCompany=true"
      );
    } else {
      navigate(pages.companyDetailsCreateEmpty.route);
    }
  }
}

// Styled Components
const CardWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  gap: 30px;
  flex-wrap: wrap;
`;

const Card = styled(Paper)`
  width: 350px;
  height: 280px;
  padding: 40px 30px;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  justify-content: start;
  text-align: center;
  background-color: white;
  box-shadow: rgba(17, 17, 26, 0.1) 0px 4px 16px;

  &:hover {
    transform: translateY(-4px);
    box-shadow: rgba(0, 0, 0, 0.08) 0px 10px 24px;
  }

  button {
    margin-top: auto;
  }
`;

const StyledAvatar = styled(Avatar)`
  margin: 0 auto 16px auto;
  width: 56px;
  height: 56px;
`;
